import { UploadFile } from "features/journey-map/modals/AddFeedback/UploadFile";
import { getExcelLibraryTemplateService, uploadExcelLibraryValue } from "features/library/reducer/LibraryActions";
import React, { memo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FlexAlignAndJustifyEnd, GenericButton, IconDispatcher } from "shared/ui-basics";
import styled from "styled-components/macro";

interface LibraryUploadFileProps {
	isOpen: boolean;
	onClose: () => void;
	libraryId: string;
	id?: string;
}

const LibraryUploadFile: React.FC<LibraryUploadFileProps> = memo(({ isOpen, onClose, libraryId, id }) => {
	const { t } = useTranslation();
	const ref = useRef<any>(null);
	const [isHaveFile, setIsFile] = useState<boolean>(false);
	const [validFile, setValidFile] = useState<boolean>(true);
	const [errorFile, setErrorFile] = useState<string>("");

	const onFailed = (msg: string) => {
		if (msg?.response?.data) setErrorFile(t(msg?.response?.data).replace("{NUB_LIMIT}", 3000));
		setValidFile(false);
		setIsFile(false);
	};
	const onSuccessImport = () => {
		toast.info(t("IMPORT_DATA_IN_PROGRESS"));
		onClose();
	};
	const startCreateData = () => {
		if (ref.current) {
			const authorizedExtensions = ["xlsx"];
			const files = ref.current.getFiles();
			if (files?.length > 0) {
				const file = files[0];
				const fileExtension = file?.name?.split(".")?.pop()?.toLowerCase();
				if (!authorizedExtensions.includes(fileExtension || "")) {
					setValidFile(false);
					setErrorFile(t("EXCEL_NOT_VALID"));
					return;
				}
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onloadend = function () {
					const base64data = reader.result as string;
					uploadExcelLibraryValue({ fileBody64: base64data.split(",")[1], libraryId, onFailed: onFailed, onSuccess: onSuccessImport });
				};
			}
		}
		// onClose();
	};

	return (
		<Modal fade={false} isOpen={isOpen} centered={true} toggle={onClose} size="lg">
			<ModalHeader toggle={onClose}>{t("IMPORT")}</ModalHeader>
			<ModalBody key={id}>
				{!validFile && (
					<WrapperInfo type="error" className="mt-2">
						<div>{IconDispatcher("triangle-exclamation", "", { style: "solid", color: "#D50000" })}</div>
						<Label>
							{t("ERROR")} : {errorFile != "" ? errorFile : t("EXCEL_NOT_VALID")}
						</Label>
					</WrapperInfo>
				)}
				<UploadFile fileUploadRef={ref} setIsFile={setIsFile} setValidFile={setValidFile} templateExportService={getExcelLibraryTemplateService} />
				<FlexAlignAndJustifyEnd className="pt-4">
					<GenericButton variant="dark" disabled={!isHaveFile || !validFile} onClick={startCreateData}>
						{t("IMPORT")}
					</GenericButton>
				</FlexAlignAndJustifyEnd>
			</ModalBody>
		</Modal>
	);
});

LibraryUploadFile.displayName = "LibraryUploadFile";
export { LibraryUploadFile };

export const WrapperInfo = styled.div<{ type: "info" | "error" }>`
	margin-bottom: 1rem;
	display: flex;
	align-items: flex-start;
	${(props) =>
		props.type === "info" &&
		`
      border: 1px solid #CBE6FF;
      background: #EAF5FF;
    `}
	${(props) =>
		props.type === "error" &&
		`
      border: 1px solid #FFD2D2;
      background: #FFEDED;
    `}
    padding: 4px;
	border-radius: 4px;
	gap: 8px;
`;

const Label = styled.div`
	color: #d50000;
	font-family: "Inter";
	font-size: 12px;
	font-style: "normal";
	font-weight: 400;
`;
